export default __webpack_public_path__ + "static/media/circle-uncheck.2cbb4a13.svg";